import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export const useCategories = () =>
  useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const res = await api.get('/categories');
      return res.data;
    },
  });

export const useDistricts = () =>
  useQuery({
    queryKey: ['districts'],
    queryFn: async () => {
      const res = await api.get('/districts');
      return res.data;
    },
  });

/** Shared published feed for homepage + breaking ticker (deduped by React Query). */
export const usePublishedFeed = () =>
  useQuery({
    queryKey: ['articles', 'published', 'feed'],
    queryFn: async () => {
      const res = await api.get('/articles?limit=50&status=PUBLISHED');
      return res.data.articles || [];
    },
  });
